globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Websites = appCustomerSpace.Modals.Websites || {};

appCustomerSpace.Modals.Websites.AuditsAppointment = (function(superClass) {

  utils.extend(AuditsAppointment, superClass);

  function AuditsAppointment($html) {
    this.$html = $html;
    this.$body = this.$html.find(".modal-body");
    this.$calendly_widget = this.$html.find(".calendly-widget");
    this.$calendly_input = this.$calendly_widget.find("#calendly-event-scheduled-datetime");

    return AuditsAppointment.__super__.constructor.apply(this, arguments);
  }

  $.extend(AuditsAppointment.prototype, {
    init: function() {
      CalendlyModule.initWidgets();
      this.events();

      return AuditsAppointment.__super__.init.apply(this, arguments);
    },
    events: function() {
      var modal = this;

      if(modal.$calendly_input.length) {
        $("body").on("calendly_event_scheduled", function() {
          $.post(
            modal.$calendly_widget.data("remote-url"),
            { debriefing_appointment_at: modal.$calendly_input.val() },
            function() {
              setTimeout(function() {
                modal.close();
                setTimeout(function() {
                  window.location.reload();
                }, 300);
              }, 1500)
            }
          )
        });
      }
    }
  });

  return AuditsAppointment;

})(appCustomerSpace.Modal);
